import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "utilities/Constant";
import type { BorrowerPersonalInformation } from "pages/dashboard/home/dashboardService";


export function extractDealServicePreferredLanguage(data?: BorrowerPersonalInformation): string | null {
  const preferredLanguage = data?.preferredLanguage;

  const value = preferredLanguage?.languageType;
    
  return value?.trim() ? value.trim() : null;
}

export function normalizeToAppLanguage(value?: string | null): string {
  if (!value?.trim()) {
    return DEFAULT_LANGUAGE;
  }

  switch (value.trim().toLowerCase()) {
    case "english":
      return "English";
    case "spanish":
    case "español":
    case "espanol":
      return "Español";
    default:
      return SUPPORTED_LANGUAGES.includes(value) ? value : DEFAULT_LANGUAGE;
  }
}

export function toUserDbPreferredLanguage(appLanguage: string): string {
  return normalizeToAppLanguage(appLanguage) === "Español" ? "Spanish" : "English";
}

export function getPreferredLanguage(reduxLanguage?: string | null): string {
  if (reduxLanguage?.trim()) {
    return normalizeToAppLanguage(reduxLanguage);
  }

  return DEFAULT_LANGUAGE;
}

export function isSpanishLanguage(value?: string | null): boolean {
  return normalizeToAppLanguage(value) === "Español";
}

export function resolvePersistedPreferredLanguage(savedLanguage?: string | null, fallbackLanguage?: string | null): string | undefined {
  if (savedLanguage?.trim()) {
    return normalizeToAppLanguage(savedLanguage);
  }

  if (fallbackLanguage?.trim()) {
    return normalizeToAppLanguage(fallbackLanguage);
  }

  return undefined;
}
